import templateUrl from "emun.on-demand/templates/composite-image-prompt.htm";
import CompositeImagePromptController from "emun.on-demand/templates/composite-image-prompt.controller";
import open from "webmodals/open";

let compositeImagePrompt = options => {
  let modalInstance = open({
    size: options.size || "xl",
    backdrop: options.backdrop || "static",
    templateUrl: options.templateUrl || templateUrl,
    controller: CompositeImagePromptController,
    bindToController: true,
    controllerAs: "$ctrl",
    resolve: {
      options: () => options
    }
  });

  return modalInstance.result;
};

export default compositeImagePrompt;
